import { useChains, useCurrencies } from "@opensea/app-kit"
import { Link } from "@opensea/navigation"
import { Avatar } from "@opensea/next-ui-kit"
import {
  FlexCenter,
  NumberDisplay,
  SkeletonLine,
  TextBody,
} from "@opensea/ui-kit"
import { NULL_ADDRESS } from "@opensea/utils"
import { useActiveChain } from "@opensea/wallet"
import { useCurrencyUrl } from "@/components/currencies/use-currency-url"

export function PageFooterNativeCurrencyPrice() {
  const activeChain = useActiveChain()
  const { getLogo } = useChains()
  const { getCurrency, getUsdPrice } = useCurrencies()
  const { getCurrencyUrlByContract } = useCurrencyUrl()

  const currencyIdentifier =
    activeChain?.nativeCurrency && activeChain.nativeCurrency.symbol !== "ETH"
      ? {
          contractAddress: activeChain.nativeCurrency.contractAddress,
          chainIdentifier: activeChain.identifier,
        }
      : getCurrency({
          contractAddress: NULL_ADDRESS,
          chainIdentifier: "ethereum",
        })

  if (!currencyIdentifier) {
    return <SkeletonLine className="h-5 w-[60px]" />
  }

  return (
    <Link
      href={getCurrencyUrlByContract(
        currencyIdentifier.chainIdentifier,
        currencyIdentifier.contractAddress,
      )}
    >
      <FlexCenter className="gap-1 text-text-secondary">
        <Avatar {...getLogo(currencyIdentifier.chainIdentifier)} size={12} />
        <TextBody size="xs">
          <NumberDisplay
            display="usd"
            value={getUsdPrice(currencyIdentifier, 1)}
          />
        </TextBody>
      </FlexCenter>
    </Link>
  )
}
